import styled from '@emotion/styled';
import { colors, Popover, PopoverDisclosure, Stack, Typography } from '@ui-components/neo.tax';
import { ReactComponent as ChevronDownIcon } from '@ui-components/neo.tax/dist/icons/chevron-down.svg';

export const EmptyStateOuter = styled(Stack)({
  flexGrow: 1,
});

export const EmptyStateInner = styled(Stack)({
  height: '66%',
});

export const GroupingItemHeader = styled(Stack)({
  transition: 'background-color 0.15s ease-in-out',
  '&:hover': {
    backgroundColor: colors.gray[50],
  },
});

export const ControlTopAlign = styled('div')({
  display: 'flex',
  flexShrink: 0,
  marginTop: 2,
});

export const GroupingItemClickableArea = styled(Stack)({
  cursor: 'pointer',
  flexGrow: 1,
  minWidth: 0,
});

export const StyledChevronDownIcon = styled(ChevronDownIcon)<{ $isExpanded: boolean }>(({ $isExpanded }) => ({
  width: '8px',
  height: '8px',
  flexShrink: 0,
  marginTop: 6,
  transform: $isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'transform 0.2s ease-in-out',
}));

export const GroupingItemTitleBlock = styled(Stack)({
  flexGrow: 1,
  minWidth: 0,
});

export const GroupingItemTitle = styled(Typography)({
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
});

export const GroupingItemRight = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  marginLeft: 'auto',
  flexShrink: 0,
  gap: 2,
});

export const GroupingItemMetaRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

export const GroupingItemCount = styled(Typography)({
  minWidth: 76,
  textAlign: 'right',
  whiteSpace: 'nowrap',
});

export const NewMatchLabel = styled(Typography)({
  whiteSpace: 'nowrap',
});

export const BareDisclosure = styled(PopoverDisclosure)({
  appearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  color: colors.gray[400],
});

export const ReasoningPopover = styled(Popover)({
  padding: '0.75rem 1rem',
  maxWidth: '22rem',
});

export const LoadingContainer = styled(Stack)({
  flexGrow: 1,
});

export const MainListContainer = styled(Stack)({
  flex: '1 1 0',
  minHeight: 0,
});
